// import './jquery.min.js';
// import './bootstrap';
import "tinymce";
import "jquery-lazy"
import Sortable from 'sortablejs';

// import * as url from "url";
// import {includes} from "lodash";
//
// import Alpine from 'alpinejs';
//
// window.Alpine = Alpine;
//
// Alpine.start();m
//
// window.prototype = this;


const navigationBar = document.getElementById("navigationBar");
const fullScreenWindow = document.getElementById("fullScreenWindow");
const useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
const isSmallScreen = window.matchMedia('(max-width: 1023.5px)').matches;

document.deleteImageFromForm = function (id, fileName, associatedFormID, fieldName) {
    let confirmed = confirm("Foto verwijderen?");
    var associatedForm = document.getElementById(associatedFormID);

    if (confirmed) {
        var newField = document.createElement('input');
        newField.setAttribute('type', 'text');
        newField.setAttribute('name', fieldName);
        newField.setAttribute('value', fileName);
        newField.setAttribute('hidden', 'true');
        associatedForm.appendChild(newField);

        document.getElementById(id).remove();
    }
}

document.openMobileMenu = function () {
    $('#mobilemenu').removeClass('close');
}

document.closeMobileMenu = function () {
    $('#mobilemenu').addClass('close');
}

function removeParam(parameter)
{
    var url=document.location.href;
    var urlparts= url.split('?');

    if (urlparts.length>=2)
    {
        var urlBase=urlparts.shift();
        var queryString=urlparts.join("?");

        var prefix = encodeURIComponent(parameter)+'=';
        var pars = queryString.split(/[&;]/g);
        for (var i= pars.length; i-->0;)
            if (pars[i].lastIndexOf(prefix, 0)!==-1)
                pars.splice(i, 1);
        url = urlBase+'?'+pars.join('&');
        window.history.pushState('',document.title,url);
    }
    return url;
}

function MenuCategorySelectorPosition() {
    const selector = document.getElementById("menuSelector");

    if (selector) {
        selector.style.top = navigationBar.clientHeight + "px";
    }
}

function detectFullScreenImages() {
    var images = document.querySelectorAll("[data-fullscreen='1']");
    images.forEach(function (item, index) {
        item.onclick = function () {
            var imageURL = "";

            if (item.tagName.toLowerCase() === "img") {
                imageURL = item.src;
            } else {
                var backgroundImageRaw = item.style.backgroundImage;
                var backgroundImageStrip = backgroundImageRaw.substring(4, backgroundImageRaw.length - 1);
                imageURL = window.location.origin + backgroundImageStrip.replaceAll("\"", "");
            }

            if (imageURL !== "") {
                fullScreenWindow.style.backgroundImage = "url('" + imageURL + "')"
                fullScreenWindow.classList.remove("hidden")
            }
        }
    });
}

document.closeFullscreen = function () {
    fullScreenWindow.style.backgroundImage = "url('')";
    fullScreenWindow.classList.add("hidden");
}

function externalLinksDetector() {
    var all_links = document.querySelectorAll('a');
    for (var i = 0; i < all_links.length; i++) {
        var a = all_links[i];
        if (a.hostname !== location.hostname) {
            a.rel = 'noopener';
            a.target = '_blank';
        }
    }
}

function textAreaDetector() {
    const textAreas = document.getElementsByTagName("textarea");
    for (let i = 0; i < textAreas.length; i++) {
        let textArea = textAreas[i];
        textArea.setAttribute("style", "height:" + (textArea.scrollHeight) + "px;overflow-y:hidden;");
        textArea.addEventListener("input", function () {
            this.style.height = 0;
            this.style.height = (this.scrollHeight) + "px";
        }, false);
    }
}

function headerNavBar() {
    var header = document.getElementsByClassName('headerNav');

    if (navigationBar != null) {
        if (header.length !== 0) {
            header = header[0];
            let scrollY = window.scrollY;
            let headerHeight = header.clientHeight;
            let navHeight = navigationBar.clientHeight;

            let threshold = headerHeight - navHeight;

            if (scrollY > threshold) {
                navigationBar.classList.remove("headerstyle");
            } else {
                navigationBar.classList.add("navAnimation");
                navigationBar.classList.add("headerstyle");
            }
        } else {
            navigationBar.style.position = "sticky";
            navigationBar.classList.remove("headerstyle");
        }
    }
}

function navTopPadding(elements) {
    var navHeight = navigationBar.clientHeight;

    Array.from(elements).forEach((element) => {
        element.style.paddingTop = navHeight + "px !important";
        console.log(element.style.backgroundImage)
    });

}

window.scrollToElement = function (id) {
    let navHeight = navigationBar.clientHeight;
    var offsetTop = document.getElementById(id).offsetTop;

    scroll({
        top: offsetTop - navHeight * 1.5,
        behavior: "smooth"
    });
}

document.selectMenu = function ($e) {
    var a = document.createElement('a');
    a.href = $e.value;
    a.rel = 'noopener';
    a.target = '_blank';
    a.style.display = 'none';
    $e.parentElement.appendChild(a);

    if (a.hostname !== location.hostname) {
        a.click();
    } else {
        window.open(menuURL + '/' + $e.value,'_self');
    }
}

document.openURL = function (url) {
    var a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener';
    a.target = '_blank';
    a.style.display = 'none';


    if (a.hostname !== location.hostname) {
        a.click();
    } else {
        window.open(url,'_self');
    }
}

document.cmsMenuToggle = function () {
    var nav = document.getElementsByTagName('nav')[0];

    if (nav.classList.contains('hidden')) {
        nav.classList.remove('hidden');
    } else {
        nav.classList.add('hidden');
    }
}

document.addRow = function (sample) {
    sample = document.getElementById(sample);
    var table = sample.parentElement;
    var newRow = sample.cloneNode(true);
    sample.id = "";

    var nextIndex = parseInt(table.getAttribute('data-loop')) + 1;
    if (isNaN(nextIndex)) {
        nextIndex = 1
    }
    table.setAttribute('data-loop', nextIndex);

    var inputs, index;
    inputs = newRow.getElementsByTagName('input');

    for (index = 0; index < inputs.length; ++index) {
        var olditem = "[" + (nextIndex - 1) + "]";
        var newItem = "[" + (nextIndex) + "]";

        if (nextIndex === 1) {
            olditem = "[0]";
        }

        var name = inputs[index].getAttribute('name').replace(olditem, newItem);

        inputs[index].setAttribute('name', name);
    }

    sample.after(newRow);
}

document.deleteRow = function (e) {
    var row = e.parentElement.parentElement;
    var table = row.parentElement;
    var previousIndex = parseInt(table.getAttribute('data-loop')) - 1;

    if(row.id !== "") {
        row.previousSibling.id = row.id;
    }

    table.setAttribute('data-loop', previousIndex);
    row.remove()
}

document.openCart = function () {
    document.getElementById("cart").classList.remove("hidden");
}

document.closeCart = function () {
    document.getElementById("cart").classList.add("hidden");
}

function reportWindowSize() {
    MenuCategorySelectorPosition();
    headerNavBar();
}

function onLoad() {
    MenuCategorySelectorPosition();
    detectFullScreenImages();
    externalLinksDetector();
    textAreaDetector();
    headerNavBar();

    var navTopPaddingElements = document.getElementsByClassName('navTopPadding');
    if (navTopPaddingElements.length !== 0) {
        navTopPadding(navTopPaddingElements);
    }

    var sortableTables = document.querySelectorAll('table.sortable');
    for (var i = 0; i < sortableTables.length; i++) {
        new SortableTable(sortableTables[i]);
    }

    var deleteFormButtons = document.getElementsByClassName('form-delete');
    for (var i = 0; i < deleteFormButtons.length; i++) {
        deleteFormButtons[i].onclick = function(btn = i) {
            if (confirm("Verwijderen?")) {
                deleteFormButtons[btn].form.submit();
            } else {
                return false;
            }
        }
    }
}

function onScroll() {
    headerNavBar();

    var parralaxs = document.getElementsByClassName("parralax");
    for (let i = 0; i < parralaxs.length; i++) {
        parralaxs[i].style.backgroundPosition = "center " + window.scrollY * 0.3 + "px";
    }
}

if (document.getElementsByClassName('wysiwyg').length > 0) {
    tinymce.init({
        selector: '.wysiwyg',
        plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
        editimage_cors_hosts: ['picsum.photos'],
        menubar: 'file edit view insert format tools table help',
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        toolbar_sticky: true,
        toolbar_sticky_offset: isSmallScreen ? 102 : 108,
        autosave_ask_before_unload: true,
        autosave_interval: '30s',
        autosave_prefix: '{path}{query}-{id}-',
        autosave_restore_when_empty: false,
        autosave_retention: '2m',
        image_advtab: true,
        link_list: sitemap,
        image_list: uploadsFolder,
        image_class_list: [
            {title: 'None', value: ''},
            {title: 'Circle Image', value: 'cc-circle-image'},
            {title: 'Rounded Corners', value: 'cc-rounded-corners-image'},
            {title: 'Full Width Image', value: 'cc-full-width-image'},
            {title: 'Rounded: Full Width Image', value: 'cc-full-width-image cc-rounded-corners-image'},
            {title: 'Half Width Desktop - Full Width Mobile', value: 'cc-mobile-full-desktop-half-image'},
            {title: 'Rounded: Half Width Desktop - Full Width Mobile', value: 'cc-mobile-full-desktop-half-image cc-rounded-corners-image'},
        ],
        importcss_append: true,
        file_picker_callback: (callback, value, meta) => {
            /* Provide file and text for the link dialog */
            if (meta.filetype === 'file') {
                callback('https://www.google.com/logos/google.jpg', {text: 'My text'});
            }

            /* Provide image and alt text for the image dialog */
            if (meta.filetype === 'image') {
                callback('https://www.google.com/logos/google.jpg', {alt: 'My alt text'});
            }

            /* Provide alternative source and posted for the media dialog */
            if (meta.filetype === 'media') {
                callback('movie.mp4', {source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg'});
            }
        },
        template_cdate_format: '[Date Created (CDATE): %d-%m-%Y : %H:%M:%S]',
        template_mdate_format: '[Date Modified (MDATE): %d-%m-%Y : %H:%M:%S]',
        height: 600,
        image_caption: true,
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        noneditable_class: 'mceNonEditable',
        toolbar_mode: 'sliding',
        contextmenu: 'link image table',
        skin: useDarkMode ? 'oxide-dark' : 'oxide',
        content_css: useDarkMode ? 'dark' : 'default',
        content_style: 'body { font-family: \'Nunito\', sans-serif; font-size:1rem }',
    });
}

window.onload = onLoad;
window.onresize = reportWindowSize;
window.onscroll = onScroll;

$(function($) {
    $("[data-lazy]").Lazy({
        attribute: "data-lazy",
    });
});

if( $('#sortable').length )
{
    var el = document.getElementById('sortable');
    var sortable = Sortable.create(el, {
        ghostClass: 'ghost',
        onChange: function(/**Event*/evt) {
            // evt.newIndex
            console.log(sortable.toArray())
        }
    });
}

document.openLanguage = function () {
    var w = document.getElementById('languageWindow');
    w.classList.remove('hidden');
}

document.closeLanguage = function () {
    var w = document.getElementById('languageWindow');
    w.classList.add('hidden');
}

document.selectLanguage = function (language) {
    document.cookie = "language="+language+"; path=/";
    document.closeLanguage();
    location.reload();
}

document.floatingButton = function (e) {
    e = $(e);
    let container = $('.floatings');
    let openItemID = container.attr('data-openitem');
    let icon = e.find('i');
    let parent = e.parent();
    let content = parent.find('.content');

    if (openItemID !== "" && openItemID !== parent.attr('id')) {
        $('#'+openItemID).find('.icon').click();
        container.attr('data-openitem', '');
    } else {
        container.attr('data-openitem', '');
    }

    if (!content.hasClass('closing')) {
        if (content.hasClass('closed')) {
            container.attr('data-openitem', parent.attr('id'));
            icon.addClass('fa-xmark')
            content.removeClass('closed');
        } else {
            icon.removeClass('fa-xmark');
            content.addClass('closing');

            setTimeout(function(){
                content.addClass('closed');
                content.removeClass('closing');
            }, 500);
        }
    }
}

function autoOpenFloatingContent() {
    let executed = getCookie('floatAutoOpenExecuted');

    if (!executed) {
        let autoOpenContent = $('#float-auto-open');
        var expires = (new Date(Date.now() + 86400*2000)).toUTCString();

        setTimeout(function(){
            autoOpenContent.click();
            document.cookie = "floatAutoOpenExecuted=true; expires=" + expires + "; path=/";
        }, 5000);
    }
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

autoOpenFloatingContent();
